module.exports = __webpack_public_path__ + "img/Wp_2048.a8ef362e.png";